import { render, staticRenderFns } from "./ExpertAppointmentDateSelection.vue?vue&type=template&id=422f9f21"
import script from "./ExpertAppointmentDateSelection.vue?vue&type=script&lang=ts"
export * from "./ExpertAppointmentDateSelection.vue?vue&type=script&lang=ts"
import style0 from "./ExpertAppointmentDateSelection.vue?vue&type=style&index=0&id=422f9f21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports